<template>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :footer-props="{'items-per-page-options': [10, 50, 100]}"
        disable-sort
    >
        <template v-slot:item="{item}">
            <tr>
                <td>
                    <div class="text-primary text-decoration-underline cursor-pointer">
                        {{ item.productName }}
                    </div>
                    <div v-if="type === 'EXCURSION'">{{ `${item.cityName}, ${item.countryName}` }}</div>
                </td>
                <template v-for="(date, index) in item.itemsByDate" :key="index">
                    <td
                        v-if="date.totalAllocatedQuantity || date.totalAvailableQuantity || date.totalBookedQuantity"
                        class="px-2 py-4"
                    >
                        <div class="mb-2 font-weight-bold">
                            {{ `${date.totalAllocatedQuantity} /` }}
                            <span class="text-success">
                                {{ date.totalBookedQuantity }}
                            </span>
                            <sup class="text-error">{{ date.totalAvailableQuantity }}</sup>
                            <span v-if="date.productRealizationPercent" class="text-grey">
                                {{ `(${date.productRealizationPercent}%)` }}
                            </span>
                            <v-btn
                                :disabled="!date.totalBookedQuantity"
                                size="small"
                                icon="mdi-finance"
                                variant="text"
                                @click="$emit('show-details', {product: item, dayIndex: index})"
                            />
                        </div>
                        <div class="text-grey">
                            {{ `${$t('gross_sales').toLowerCase()}:` }}
                            {{ $filters.priceFormat(date.grossSales, date.currency) }}
                        </div>
                        <!--<div class="grey&#45;&#45;text">-->
                        <!--    {{ `${$t('price').toLowerCase()} ${$t('from').toLowerCase()}:` }}-->
                        <!--    {{ $filters.priceFormat(999.99, date.currency) }}-->
                        <!--</div>-->
                    </td>
                    <td v-else />
                </template>
            </tr>
        </template>
    </v-data-table>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class SalesMonitoringReportTable extends Vue {
        @Prop({default: () => [], type: Array}) statisticsData
        @Prop({default: () => false, type: Boolean}) isLoading
        @Prop({type: String}) type

        get headers() {
            const headers = [{title: '', key: 'name', minWidth: '250px', width: '250px'}]

            this.statisticsData.map(product => {
                product.itemsByDate.reduce((list, item) => {
                    const date = item.date.split(' ')[0]

                    if (list.every(header => header.key !== date)) {
                        list.push({
                            title: this.$filters.dateFormat(item.date),
                            key: date,
                            minWidth: '160px',
                            width: '160px',
                        })
                    }

                    return list
                }, headers)
            })

            return headers
        }

        get items() {
            return this.statisticsData
                .filter(({itemsByDate}) =>
                    itemsByDate.find(
                        date => date.totalAllocatedQuantity || date.totalAvailableQuantity || date.totalBookedQuantity
                    )
                )
                .sort((a, b) => (a.productName > b.productName ? 1 : -1))
        }
    }

    export default SalesMonitoringReportTable
</script>
